module.exports = __webpack_public_path__ + "img/debtPayingAbility10.bffe7a06.png";